/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Confirm_DeleteInputs */

const cs_automation_confirm_delete = /** @type {(inputs: Automation_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat tento workflow?`)
};

const en_automation_confirm_delete = /** @type {(inputs: Automation_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this workflow?`)
};

/**
* | output |
* | --- |
* | "Delete this workflow?" |
*
* @param {Automation_Confirm_DeleteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_confirm_delete = /** @type {((inputs?: Automation_Confirm_DeleteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Confirm_DeleteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_confirm_delete(inputs)
	return cs_automation_confirm_delete(inputs)
});